export class ConfigFetchFailedError extends Error {
  constructor() {
    super(`Config Fetch was not OK`);
  }
}

